import React from "react";
import { Badge, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  singleBoggy: {
    width: "fit-content",
    backgroundColor: "#0000FF",
    color: "white",
    padding: "5px 12px",
    marginBottom: 0,
  },
  doubleBoggy: {
    width: "fit-content",
    backgroundColor: "black",
    color: "white",
    padding: "5px 12px",
    marginBottom: 0,
  },
  birdy: {
    width: "fit-content",
    backgroundColor: "#FF0000",
    color: "white",
    padding: "5px 12px",
    marginBottom: 0,
    borderRadius: "50%",
  },
  eagle: {
    width: "fit-content",
    backgroundColor: "#FFC700",
    color: "white",
    padding: "5px 12px",
    marginBottom: 0,
    borderRadius: "50%",
  },
  nothing: {
    width: "fit-content",
    padding: "5px 12px",
    marginBottom: 0,
    border: "1px solid #ccc",
  },
}));

const CellColorTypography = ({ data }) => {
  const classes = useStyles();
  return (
    <Badge
      color="secondary"
      badgeContent={data?.advantage ? 1 : 0}
      sx={{
        "& .MuiBadge-badge": {
          marginTop: "4px",
          width: "10px",
          height: "18px",
          borderRadius: "50%",
          fontSize: "10px",
        },
      }}
    >
      {data?.score > data?.par ? (
        <Typography
          className={
            data?.par + 1 === data?.score
              ? classes.singleBoggy
              : classes.doubleBoggy
          }
        >
          {data?.score}
        </Typography>
      ) : data?.score < data.par ? (
        <Typography
          className={
            data?.score + 1 === data.par
              ? classes.birdy
              : data.score + 2 === data.par
              ? classes.eagle
              : data.advantage
              ? classes.nothing
              : null
          }
        >
          {data.score}
        </Typography>
      ) : (
        <Typography
          className={
            data?.score + 1 === data?.par
              ? classes.birdy
              : data?.score + 2 === data?.par
              ? classes.eagle
              : data?.advantage
              ? classes.nothing
              : null
          }
        >
          {data?.score}
        </Typography>
      )}
    </Badge>
  );
};

export default CellColorTypography;
